import {
  apiRoute,
  apiOrigin,
  requestPost,
  requestFormPost,
  requestUrlParamsPost,
} from "@lib/api/api";
import { BasicAPIResponseType } from "@typedef/API.types";
import { LoginAccessDataType } from "@typedef/components/Login/Login.types";
import React, { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../Login";
import useAuth from "@hooks/Auth/useAuth";

const LoginContainer = () => {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");

  //login
  const login = useCallback(async () => {
    const params = new URLSearchParams();
    params.append("userName", id);
    params.append("password", password);

    const { data, status } = await requestUrlParamsPost<
      BasicAPIResponseType<LoginAccessDataType>
    >(`${apiOrigin}${apiRoute.login}`, {}, params);
    console.log(data);

    sessionStorage.setItem("@access", data.accessToken);

    navigate("/post");
  }, [id, password]);

  // submit
  const onLoginSubmitted = useCallback(() => {
    login();
  }, [login]);

  return (
    <Login
      onLoginSubmitted={onLoginSubmitted}
      setId={setId}
      setPassword={setPassword}
      id={id}
      password={password}
    />
  );
};

export default LoginContainer;
